document.addEventListener('DOMContentLoaded', function () {
  initFilterTabs();
  initProductSliders();
  initProductSwatches();
});

/* --- Filter Tabs --- */
function initFilterTabs() {
  document.querySelectorAll('[data-filter-tabs]').forEach(function (tabGroup) {
    const section = tabGroup.closest('.product-slider-section');
    if (!section) return;

    const tabs = tabGroup.querySelectorAll('.filter-tabs__btn');
    const panels = section.querySelectorAll('.product-slider-section__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = tab.dataset.tabTarget;
        if (!target) return;

        tabs.forEach(function (item) {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          const isActive = panel.dataset.panel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        const activePanel = section.querySelector(
          '.product-slider-section__panel.is-active [data-product-slider]'
        );
        if (activePanel) {
          const swiperEl = initSingleProductSlider(activePanel);
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
            swiperEl.swiper.slideTo(0, 0);
          }
        }
      });
    });
  });
}

/* --- Product Swiper Sliders --- */
function initProductSliders() {
  document.querySelectorAll('[data-product-slider]').forEach(function (sliderWrap) {
    const panel = sliderWrap.closest('.product-slider-section__panel');
    if (panel && panel.hidden) return;
    initSingleProductSlider(sliderWrap);
  });
}

/* Duplicate slides so arrows + scrollbar always have room to move */
function duplicateSliderSlides(swiperEl, times) {
  if (swiperEl.dataset.slidesDuplicated === 'true') return;

  const wrapper = swiperEl.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
  if (slides.length < 1) return;

  for (var pass = 0; pass < times; pass += 1) {
    slides.forEach(function (slide) {
      wrapper.appendChild(slide.cloneNode(true));
    });
  }

  swiperEl.dataset.slidesDuplicated = 'true';
}

function initSingleProductSlider(sliderWrap) {
  if (sliderWrap.dataset.swiperInit === 'true') {
    return sliderWrap.querySelector('.swiper');
  }

  const swiperEl = sliderWrap.querySelector('.swiper');
  const prevBtn = sliderWrap.querySelector('.product-slider__nav--prev');
  const nextBtn = sliderWrap.querySelector('.product-slider__nav--next');
  const scrollbarEl = sliderWrap.querySelector('.product-slider__scrollbar');

  if (!swiperEl) return null;

  /* Repeat cards twice (4 → 12) for smooth scroll + progress bar */
  duplicateSliderSlides(swiperEl, 2);

  new Swiper(swiperEl, {
    slidesPerView: 1.28,
    spaceBetween: 12,
    speed: 600,
    grabCursor: true,
    slidesPerGroup: 1,
    watchSlidesProgress: true,
    watchOverflow: false,
    resistanceRatio: 0.85,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    scrollbar: {
      el: scrollbarEl,
      draggable: true,
      hide: false,
      snapOnRelease: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        spaceBetween: 16,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

  sliderWrap.dataset.swiperInit = 'true';
  return swiperEl;
}

/* --- Color swatch selection (works on cloned cards too) --- */
function initProductSwatches() {
  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.product-card__swatch');
    if (!swatch) return;

    const group = swatch.closest('.product-card__swatches');
    if (!group) return;

    group.querySelectorAll('.product-card__swatch').forEach(function (item) {
      item.classList.remove('is-active');
    });
    swatch.classList.add('is-active');
  });
}